import { UPDATE_PACKAGE_BOXES_FAILURE, UPDATE_PACKAGE_BOXES_REQUEST, UPDATE_PACKAGE_BOXES_SUCCESS } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const updatePackageBoxesReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_PACKAGE_BOXES_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case UPDATE_PACKAGE_BOXES_REQUEST:
            return Object.assign({}, state);
        case UPDATE_PACKAGE_BOXES_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default updatePackageBoxesReducer;
